export const ORDER_TYPES = {
  LETTER: 1,
  FOLLOW_CALL: 2,
}



// WEBPACK FOOTER //
// ./src/constants/OrderValues.js